import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import {
  WHITE, PINK
} from '../../../constants/colors';


export default {
  categoryfilter: ({ activebutton }) => {
    const style = css`
      cursor: pointer;
      display: inline-block;
      padding: 6px 20px;
      margin-right: 10px;
      border: 1px solid ${WHITE};
      border-radius: 4px;
      font-size: ${rem('14px')};
      color: ${WHITE} !important;
      margin-bottom: 10px;
      ${media.md`
        padding:6px 25px;
      `};
      ${activebutton &&
        css`
          border: 1px solid ${PINK};
          background-color: ${PINK};
        `}
    `;
    return style;
  }
};
